import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppModuleShared } from './shared/app.shared.module';
import { AppComponent } from './main/app.component';
import { RedirectURLService, SharedProfileService, CommonUserService } from './shared/index'

@NgModule({
    bootstrap: [ AppComponent ],
    imports: [
        BrowserModule,
        AppModuleShared        
    ],
    providers: [
        RedirectURLService,
        SharedProfileService,
        CommonUserService,
        { provide: 'BASE_URL', useFactory: getBaseUrl }
    ]
})
export class AppModule {
}

export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}
